const page_home = document.getElementById("page-home");

if (page_home) {
  //!---------- Landing Hero Section - Video ----------
  const button_video = page_home.querySelector(".btn-video");

  button_video.onclick = (event) => {
    //% Ignore click if not made by user
    if (!event.isTrusted) {
      console.warn("Programmatic click detected, ignoring...");
      return;
    }

    //% Trigger video_mount event used to open video modal
    triggerEvent(window, "video_mount");
  };

  //!---------- Conservation Section ----------

  //!---------- Explore Lodge Slider Section ----------
  const section_explore = page_home.querySelector("section.explore");

  if (section_explore) {
    const slides = section_explore.querySelectorAll(".slide");
    const btn_prev = section_explore.querySelector(".btn.prev");
    const btn_next = section_explore.querySelector(".btn.next");
    const pagination_bullets = section_explore.querySelectorAll(".pagination .bullet");

    const slide_count = slides.length;
    let current_index = 0;
    let isBusy = false;

    //% Initial setup - Make the first slide active and set pagination bullet
    slides[0].classList.add("active");
    pagination_bullets[current_index].classList.add("active");

    //% Click Event for Previous and Next buttons
    btn_next.onclick = () => shiftSlide("forward");
    btn_prev.onclick = () => shiftSlide("backward");

    function shiftSlide(direction = "forward") {
      //% Exit if animation still busy
      if (isBusy) {
        return;
      }

      //% Mark busy state to disable nav buttons
      isBusy = true;

      //% Store currently active slide
      const current_slide = slides[current_index];
      let next_index;

      //% Set next slide based on direction of navigation
      if (direction === "forward") {
        //$ Set the next index to the next item in the array
        next_index = current_index === slide_count - 1 ? 0 : current_index + 1;
      } else if (direction === "backward") {
        //$ Set the next index to the previous item in the array
        next_index = current_index === 0 ? slide_count - 1 : current_index - 1;
      } else {
        console.log("Invalid direction argument passed to shiftSlide()");
        return;
      }

      const next_slide = slides[next_index];

      //% Start transition on active slide by adding exit class and removing active
      current_slide.classList.remove("active");
      current_slide.classList.add("exit");

      //% Once the current slide has finished it's exit animation, remove the 'exit' class
      //% 'outline-offset' is used here as a dummy transition property because it has no real effect
      //% This check ensures it only triggers once
      current_slide.ontransitionend = (event) => {
        // skip execution if the transitioned property is not 'outline-offset (on slide root)
        if (event.propertyName !== "outline-offset") {
          return;
        }
        current_slide.classList.remove("exit");
      };

      //% Change the current index based on direction of navigation
      if (direction === "forward") {
        current_index = current_index === slide_count - 1 ? 0 : current_index + 1;
      }
      //$ If direction is 'backward' aka not 'forward'
      else {
        current_index = current_index === 0 ? slide_count - 1 : current_index - 1;
      }

      //% Update the pagination active bullet
      pagination_bullets.forEach((bullet) => {
        bullet.classList.remove("active");
      });
      pagination_bullets[current_index].classList.add("active");

      //% One the current index have updated add the active class to the new current slide
      //% to start it's entry animation
      slides[current_index].classList.add("active");

      //% Re-enable the button after the entry animation is done
      //$ 'outline-offset' is used here as a dummy transition property because it has no real effect
      next_slide.ontransitionend = (event) => {
        // skip execution if the transitioned property is not 'outline-offset (on slide root)
        if (event.propertyName !== "outline-offset") {
          return;
        }
        isBusy = false;
        console.log("entry animation ended");
      };
    }

    // //@ Click Event for Next button
    // btn_next.onclick = (event) => {
    //   //% Exit if animation still busy
    //   if (isBusy) {
    //     return;
    //   }

    //   //% Mark busy state
    //   isBusy = true;

    //   //% Store currently active slide
    //   const current_slide = slides[current_index];

    //   //% Store previous and next slides to use for disabling the nav buttons
    //   //^next slide for next button
    //   //? ensure that when index is at the last item in array it jumps back to the start at [0]
    //   const next_index = current_index === slide_count - 1 ? 0 : current_index + 1;
    //   const next_slide = slides[next_index];

    //   //% Start transition on active slide by adding exit class and removing active
    //   current_slide.classList.remove("active");
    //   current_slide.classList.add("exit");

    //   //% Once the current slide has finished it's exit animation...
    //   current_slide.ontransitionend = (event) => {
    //     //$ event triggers for every property transition, this check ensures it only triggers once
    //     //$ 'outline-offset' is used here as a dummy transition property because it has no real effect
    //     if (event.propertyName !== "outline-offset") {
    //       return;
    //     }
    //     current_slide.classList.remove("exit");
    //   };

    //   //% Progress the slide index forward or backward based on direction
    //   if (current_index === slide_count - 1) {
    //     current_index = 0;
    //   } else {
    //     current_index++;
    //   }

    //   //% One the current index have updated add the active class to the new current slide
    //   //% to start it's entry animation
    //   slides[current_index].classList.add("active");

    //   //% Re-enable the button after the entry animation is done
    //   //$ 'outline-offset' is used here as a dummy transition property because it has no real effect
    //   next_slide.ontransitionend = (event) => {
    //     // skip execution if the transitioned property is not 'outline-offset (on slide root)
    //     if (event.propertyName !== "outline-offset") {
    //       return;
    //     }
    //     isBusy = false;
    //     console.log("entry animation ended");
    //   };
    // };
  }

  //!---------- Experience Section - Swiper ----------

  const section_experience = page_home.querySelector("section.experiencexx") ?? null;

  // if (section_experience) {}
}
